export default __webpack_public_path__ + "static/media/1.9ac4a3a5.png";